import { getCollection } from '@adornis/baseql/server/collections.js';
import { Participation } from '../../entities/Participation.js';
import { ParticipationState } from '../../enums/enums.js';
import type { PaymentPlugin } from '../plugin-types.js';
import { defaultPaymentPlugin } from './default.js';

export const immediateParticipationPaymentPlugin: PaymentPlugin<'card' | 'paypal', 'default'> = {
  id: 'payment::immediate-participation',
  type: 'payment',
  paymentMethods: defaultPaymentPlugin.paymentMethods,
  getProductPrice: defaultPaymentPlugin.getProductPrice,
  createPayment: defaultPaymentPlugin.createPayment,
  pay: defaultPaymentPlugin.pay,
  sendInvoice: defaultPaymentPlugin.sendInvoice,
  cancleEnrollment: defaultPaymentPlugin.cancleEnrollment,
  onPaymentUpdate: defaultPaymentPlugin.onPaymentUpdate,
  priceGroups: defaultPaymentPlugin.priceGroups,
  afterEnrollment: async participationID => {
    await defaultPaymentPlugin.afterEnrollment(participationID);
    const c = await getCollection(Participation);
    await c.updateOne({ _id: participationID }, { $set: { state: ParticipationState.PARTICIPATED } });
  },
};
